@for (banner of banners$ | async; track banner) {
  <div>
    @switch (banner.variant) {
      <!-- Banner bar (unchanged aside from using banner.message) -->
      @case ("bar") {
        <div
          class="banner"
          [ngClass]="'banner--' + banner.level"
          [attr.role]="banner.level === 'error' ? 'alert' : 'status'"
          [attr.tabindex]="banner.focusOnShow ? 0 : -1"
        >
          <div class="banner__content">
            <span class="banner__icon" aria-hidden="true"></span>
            <span class="banner__text">{{ banner.message }}</span>
          </div>
          @if (banner.ctAs?.length) {
            <div class="banner__ctas">
              @for (c of banner.ctAs; track c) {
                <sui-button
                  [variant]="c.type === 'primary' ? 'primary' : 'secondary'"
                  (click)="onCta(c)"
                >
                  {{
                    c.label ||
                      (c.i18nKey ? (c.i18nKey | translate: c.meta) : "")
                  }}
                </sui-button>
              }
            </div>
          }
          <button
            class="banner__close"
            aria-label="Dismiss"
            (click)="dismiss(banner.id)"
          >
            ×
          </button>
        </div>
      }
      <!-- Dialog overlay -->
      @case ("dialog") {
        <div
          class="banner-dialog-overlay"
          role="dialog"
          aria-modal="true"
          [attr.aria-labelledby]="'banner-title-' + banner.id"
          (click)="dismiss(banner.id)"
        >
          <div
            class="banner-dialog"
            [ngClass]="['banner-' + banner.level, 'banner-dialog--tinted']"
            (click)="$event.stopPropagation()"
          >
            <button
              class="banner-dialog__close"
              aria-label="Close"
              (click)="dismiss(banner.id)"
            >
              ×
            </button>
            <div class="banner-dialog__header">
              <span
                class="icon"
                [ngClass]="'icon--' + banner.level"
                aria-hidden="true"
              ></span>
              <h3 class="title" [id]="'banner-title-' + banner.id">
                {{ banner.level | titlecase }}
              </h3>
            </div>
            <div class="banner-dialog__body">
              <p class="banner-dialog__message">
                <span [innerHTML]="getSafeHtml(banner.message)"></span>
              </p>
              <sui-button
                variant="ghost"
                [leadingIcon]="'copy'"
                [iconOnly]="true"
                ariaLabel="Copy message"
                (click)="copyMessage(banner)"
              ></sui-button>
              <!-- Action row: copy message / toggle details -->
              <!-- Render toggle only if details/full JSON exist -->
              @if (hasAnyDetails(banner)) {
                <sui-button
                  variant="ghost"
                  [leadingIcon]="
                    isExpanded(banner.id) ? 'chevron-up' : 'chevron-down'
                  "
                  (click)="toggleDetails(banner.id)"
                >
                  {{ isExpanded(banner.id) ? "Hide details" : "Show details" }}
                </sui-button>
              }
              <!-- Details (pretty JSON) -->
            </div>
            @if (isExpanded(banner.id)) {
              <section class="banner-dialog__details">
                <header class="details__header">
                  <span>Details</span>
                  <div class="details__actions">
                    <sui-button
                      variant="ghost"
                      [leadingIcon]="'copy'"
                      (click)="copyDetailsJson(banner)"
                    >
                      Copy details JSON
                    </sui-button>
                    <sui-button
                      variant="ghost"
                      [leadingIcon]="'copy'"
                      (click)="copyFullErrorJson(banner)"
                    >
                      Copy full error JSON
                    </sui-button>
                  </div>
                </header>
                <!-- Pretty printed, safe (text only) -->
                <pre
                  class="details__pre"
                  [innerText]="getSafeHtml(buildDetailsJson(banner))"
                ></pre>
              </section>
            }
            <div class="banner-dialog__footer">
              @for (c of banner.ctAs; track c) {
                <sui-button
                  [variant]="c.type === 'primary' ? 'primary' : 'secondary'"
                  [leadingIcon]="c.icon"
                  (click)="onCta(c)"
                >
                  {{
                    c.label ||
                      (c.i18nKey ? (c.i18nKey | translate: c.meta) : "")
                  }}
                </sui-button>
              }
            </div>
          </div>
        </div>
      }
    }
  </div>
}
